"use client";

import { c as _c } from "react/compiler-runtime";
import { addReview } from "@/actions/course-review";
import FormErrorText from "@/components/form/form-error-text";
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import ButtonWithLoader from "@/components/utility/button-with-loader";
import { ZCourseReviewDBSchema } from "@/types/types";
import { courseReviewCreateSchema } from "@/types/zod-types";
import { cn } from "@/utils/helpers";
import { tryCatch } from "@/utils/validators";
import { useAuth } from "@clerk/nextjs";
import { Star } from "lucide-react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { z } from "zod";
type ReviewFormProps = {
  rating: number;
  courseId: string;
  setRating: (value: number) => void;
  setIsOpen: (value: boolean) => void;
};
export default function ReviewForm(t0) {
  const $ = _c(36);
  const {
    rating,
    courseId,
    setRating,
    setIsOpen
  } = t0;
  const form = useForm();
  const {
    setValue,
    control,
    handleSubmit,
    formState: t1
  } = form;
  const {
    errors,
    isSubmitting
  } = t1;
  const {
    userId
  } = useAuth();
  let t2;
  let t3;
  if ($[0] !== rating || $[1] !== setValue) {
    t2 = () => {
      setValue("rating", rating);
    };
    t3 = [rating, setValue];
    $[0] = rating;
    $[1] = setValue;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== courseId || $[5] !== setIsOpen || $[6] !== userId) {
    t4 = async function handleAddReview(formData) {
      if (!userId) {
        toast.warning("Please sign in to add a review.");
        return;
      }
      const reviewData = {
        ...formData,
        courseId,
        userId
      };
      const {
        error
      } = await tryCatch(addReview(reviewData));
      if (error) {
        toast.error(error.message);
        return;
      }
      setIsOpen(false);
      toast.success("Review added \uD83C\uDF89");
    };
    $[4] = courseId;
    $[5] = setIsOpen;
    $[6] = userId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleAddReview = t4;
  let t5;
  if ($[8] !== handleAddReview || $[9] !== handleSubmit) {
    t5 = handleSubmit(handleAddReview);
    $[8] = handleAddReview;
    $[9] = handleSubmit;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== control) {
    t6 = <FormField control={control} name="description" render={_temp} />;
    $[11] = control;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = Array.from({
      length: 5
    });
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== rating || $[15] !== setRating || $[16] !== setValue) {
    t8 = <div className="mx-auto flex w-fit gap-10 py-8">{t7.map((_, i) => {
        const starNumber = i + 1;
        return <Star key={i} size={22} className={cn("cursor-pointer stroke-muted-foreground", starNumber <= rating && "fill-reviewStar stroke-reviewStar")} onClick={() => {
          setRating(starNumber);
          setValue("rating", starNumber);
        }} />;
      })}</div>;
    $[14] = rating;
    $[15] = setRating;
    $[16] = setValue;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== errors.rating) {
    t9 = errors.rating && <FormErrorText>{errors.rating.message}</FormErrorText>;
    $[18] = errors.rating;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== setIsOpen) {
    t10 = <Button variant="outline" onClick={() => setIsOpen(false)}>Discard</Button>;
    $[20] = setIsOpen;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isSubmitting) {
    t11 = <ButtonWithLoader type="submit" pending={isSubmitting}>Submit</ButtonWithLoader>;
    $[22] = isSubmitting;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = <DialogFooter>{t10}{t11}</DialogFooter>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t5 || $[29] !== t6 || $[30] !== t8 || $[31] !== t9) {
    t13 = <form onSubmit={t5}>{t6}{t8}{t9}{t12}</form>;
    $[27] = t12;
    $[28] = t5;
    $[29] = t6;
    $[30] = t8;
    $[31] = t9;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== form || $[34] !== t13) {
    t14 = <Form {...form}>{t13}</Form>;
    $[33] = form;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}
function _temp(t0) {
  const {
    field
  } = t0;
  return <FormItem><FormControl><Textarea {...field} value={field.value || ""} placeholder="Write a review..." /></FormControl><FormMessage /></FormItem>;
}